/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 27 Jan 2025
 * Time: 3:14 PM
 * Email: mdmehedihasanroni28@gmail.com
 */

import React, {createContext, useState} from 'react';
import PaymentMethodService from "../services/PaymentMethodService";
import {getErrorMessage} from "../helpers/Utils";
import {Toast} from "../components/common/Toast";

export const PaymentMethodContext = createContext("PaymentMethodContext");

const PaymentMethodContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState([]);

    const getAllPaymentMethod = async params => {
        try {

            setLoading(true);

            const res = await PaymentMethodService.getAllPaymentMethod(params);
            setPaymentMethods(res.data);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <PaymentMethodContext.Provider
            value={{
                loading,
                paymentMethods,
                getAllPaymentMethod,
            }}
        >
            {children}
        </PaymentMethodContext.Provider>
    );
}

export default PaymentMethodContextProvider;
